<template>
    <div class="grid-container content-padding">
        <div class="grid-x">
            <div class="cell large-5">
                <page-header title="Contact"></page-header>
                <div class="page-background show-for-large">
                    <picture>
                        <img alt="Page background" srcset="/media/static/inner_page.jpg 1x, /media/static/inner_page_2x.jpg 2x" class="lazy">
                    </picture>
                </div>
            </div>
            <div class="cell contact-container large-4 large-offset-1">
                <div v-if="contactPhone">
                    <p class="display-4 semi-bold margin-bottom-0">By Phone</p>
                    <p><a :href="`tel: ${contactPhone}`" class="underline color-primary bold display-large">{{ contactPhone }}</a></p>
                </div>
                <div v-if="contactEmail">
                    <p class="display-4 semi-bold margin-bottom-0">By Email</p>
                    <p><a :href="`mailto: ${contactEmail}`" class="underline color-primary bold display-large">{{ contactEmail }}</a></p>
                </div>
                <p class="color-battleship-gray display-large">Reason for contact</p>
                <div class="radio-container">
                    <checkbox label="General" :label-left="true" :radio="true" :checked="contactReason === 'contact'" @change="contactReason = 'contact'"></checkbox>
                </div>
                <div class="radio-container">
                    <checkbox label="Order issues" :label-left="true" :radio="true" :checked="contactReason === 'order'" @change="contactReason = 'order'"></checkbox>
                </div>
                <div class="grid-x contact-info" >
                    <div class="cell">
                        <p class="display-large color-battleship-gray">Your contact info</p>
                        <text-input label="Email" :value="email" @change="email = $event" :error-message="(errors.email) ? errors.email : ''"></text-input>
                        <text-input label="Name" :value="name" @change="name = $event" :error-message="(errors.name) ? errors.name : ''"></text-input>
                        <text-input placeholder="Your message" :textarea="true" :value="message" @change="message = $event" :error-message="(errors.message) ? errors.message : ''"></text-input>
                        <alert class="margin-bottom-10" v-if="success" :type="AlertType.SUCCESS" title="Thanks for contacting us">We will get back to you as soon as possible.</alert>
                        <alert class="margin-bottom-10" v-else-if="success === false" :type="AlertType.WARNING" title="Something went wrong">Sorry, we were unable to send your message. Please try again.</alert>
                        <button class="button expanded margin-top-10" :disabled="isLoading" @click.prevent="validateForm">Send</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import TextInput from '@/components/common/forms/TextInput.vue';
import Checkbox from '@/components/common/ui/Checkbox.vue';
import PageHeader from '@/components/front/ui/PageHeader.vue';
import Alert from '@/components/common/ui/Alert.vue';
import { AlertType } from '@/utils/types';
import { Icon } from '@/front/icons';
import { load as loadRecaptcha } from 'recaptcha-v3';
import api from '@/models/api';
import Settings, { SettingNamespace } from '@/utils/settings';
@Component({
    components: { TextInput, Checkbox, PageHeader, Alert }
})
export default class ContactPage extends Vue {

    contactReason: string | null = 'contact';
    email: string | null = null;
    name: string | null = null;
    message: string | null = null;
    errors: {[k: string]: string} = {};
    success: boolean | null = null;
    contactEmail: string = '';
    contactPhone: string = '';
    isLoading: boolean = false;

    async created() {
        const settings = await Settings.getInstance();
        this.contactEmail = settings.get(SettingNamespace.CONTENT, 'contact_email')?.value;
        this.contactPhone = settings.get(SettingNamespace.CONTENT, 'contact_phone')?.value;
    }

    get Icon() {
        return Icon;
    }

    get AlertType() {
        return AlertType;
    }

    public async sendMessage() {
        this.isLoading = true;
        const recaptcha = await loadRecaptcha((<any>window).captchaKey, {autoHideBadge: true, useRecaptchaNet: true});
        const token = await recaptcha.execute('create_user');
        const response = await api.post<null>({name: 'contact.message'}, {
            captcha_response: token,
            contactReason: this.contactReason,
            email: this.email,
            name: this.name,
            message: this.message
        });
        this.isLoading = false;
        this.success = response.success;
    }

    public validateForm() {
        this.errors = {};
        if (!this.name) {
            this.errors.name = 'Name required';
        }
        if (!this.email) {
            this.errors.email = 'Email required';
        } else if (!this.validEmail(this.email)) {
            this.errors.email = 'Valid email required.';
        }
        if (!this.message) {
            this.errors.message = 'Message required';
        }
        if (Object.keys(this.errors).length === 0) {
            this.sendMessage();
        }
    }

    public validEmail(email: string) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
}
</script>
<style lang="scss" scoped>
@import '~foundation-sites/scss/foundation';
@import '../../../sass/front/settings';

.radio-container {
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--light-gray);
}
.contact-container {
    padding-top: 100px;

    @include breakpoint (medium down) {
        padding-top: 160px;
    }
    .contact-info {
        padding-top: 20px;
    }
}
</style>

